




















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class DataBoardBox extends Vue {
  public name = 'DataBoardBox'

  @Prop({ default: true })
  public showTitle!: boolean

  @Prop({ default: '' })
  public boxClass!: string

  public get className(): string {
    if (this.boxClass != '') {
      return 'box ' + this.boxClass
    }
    return 'box'
  }

}
